import React from 'react'
import { DotsVerticalIcon } from 'src/editor/shared/icons/dots-vertical-icon'
import { Settings02Icon } from 'src/editor/shared/icons/settings-02-icon'
import { Trash01Icon } from 'src/editor/shared/icons/trash-01-icon'
import { ActionMenu } from 'src/editor/shared/ui-lib/action-menu'
import { GhostIconButton } from 'src/editor/shared/ui-lib/buttons'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { BlogCategoryMockItem } from 'src/shared/mocks/website-blog-categories.mock'
import { BlogCategoryActionItemEnum, BlogPostFilterEnum } from '../enums'
import { PostsListing } from './posts-listing'

interface CategoryPostsListingProps {
  category: BlogCategoryMockItem
  activePostFilter: BlogPostFilterEnum
  searchValue: string
  onOpenCategorySettings: () => void
  onOpenPostSettings: (postId: string) => void
  onSchedulePost: (postId: string) => void
}

export const CategoryPostsListing = ({
  category,
  activePostFilter,
  searchValue,
  onOpenCategorySettings,
  onOpenPostSettings,
  onSchedulePost,
}: CategoryPostsListingProps) => {
  const { t } = useTypedTranslation()

  return (
    <>
      <div className="flex items-center justify-between gap-3">
        <span className="min-w-0 flex-1 truncate text-heading-4">
          {category.name}
        </span>
        <ActionMenu
          items={[
            {
              id: BlogCategoryActionItemEnum.Settings,
              label: t(
                'website_settings.sidebar.blog.categories.actions.settings',
              ),
              iconBefore: () => <Settings02Icon className="h-5 w-5" />,
            },
            {
              id: BlogCategoryActionItemEnum.Delete,
              label: t(
                'website_settings.sidebar.blog.categories.actions.remove',
              ),
              iconBefore: () => <Trash01Icon className="h-5 w-5" />,
            },
          ]}
          onSelect={action => {
            if (action === BlogCategoryActionItemEnum.Settings) {
              onOpenCategorySettings()
            }

            if (action === BlogCategoryActionItemEnum.Delete) {
              // TODO: open delete category modal.
            }
          }}
          triggerElement={setIsOpened => (
            <GhostIconButton
              onClick={() => setIsOpened(true)}
              icon={<DotsVerticalIcon className="fill-iconSecondary" />}
            />
          )}
        />
      </div>
      <PostsListing
        activePostFilter={activePostFilter}
        searchValue={searchValue}
        onOpenPostSettings={onOpenPostSettings}
        onSchedulePost={onSchedulePost}
      />
    </>
  )
}
